import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const faqs = [
  { q: '歪歪漫画多久更新一次？', a: '人气短篇基本每日更新，通常在每日晚间集中上线。睡前点开就能看到新鲜内容，通勤路上也能顺手追更。' },
  { q: '漫画看多了需要付费吗？', a: '歪歪漫画所有短篇日常内容均免费观看。无论是摸鱼、睡前还是通勤，都能随时随地碎片快看，追更无压力。' },
  { q: '支持哪些设备阅读？', a: '电脑、平板、手机全端适配。地铁公交上打开就能看，画面清晰不卡顿，体验流畅。' },
  { q: '如何找到我喜欢的漫画类型？', a: '你可以在首页「热门短篇分类」或漫画合集页的筛选栏，按日常搞笑、职场摸鱼、睡前治愈、通勤解闷等分类快速筛选，也可以用顶部的搜索框直接搜索标题或标签。' },
  { q: '为什么有的漫画显示「今日更新」？', a: '标注「今日更新」的短篇是当天刚上线的新内容，我们会持续产出，让你每天都有新鲜的减压内容可看。' },
  { q: '我想看更多的睡前治愈内容，有推荐吗？', a: '首页「编辑精选」板块收录了编辑部私藏的治愈短篇，你也可以在漫画合集页点击「睡前治愈」分类，那里集中了所有治愈系内容。' },
  { q: '遇到阅读问题或想反馈建议怎么办？', a: '欢迎通过「联系我们」页面给我们留言，告诉我们你遇到的任何问题或想看的漫画类型，我们会认真查看每一条反馈。' },
];

export default function FaqPage() {
  const [open, setOpen] = useState(0);

  useEffect(() => {
    document.title = '常见问题 · 追更与阅读帮助 | 韩国歪歪漫画';

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="bg-background-100 pt-24 pb-8 md:pt-32 md:pb-10">
        <div className="mx-auto max-w-4xl px-4 md:px-6">
          <nav className="text-xs text-foreground-600" aria-label="面包屑">
            <ol className="flex flex-wrap items-center gap-1">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-foreground-900">常见问题</li>
            </ol>
          </nav>
          <h1 className="mt-4 font-heading text-4xl text-foreground-950 md:text-5xl">常见问题</h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            关于追更、阅读与反馈的常见疑问，这里都帮你解答了。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 md:px-6 py-10 md:py-14">
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 p-5 text-left"
                >
                  <h2 className="font-medium text-foreground-950">{f.q}</h2>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-700'}`}>
                    <i className={`text-lg transition-transform ${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-2xl bg-accent-100 p-8 text-center">
          <h3 className="font-heading text-2xl text-accent-900">还有别的问题？</h3>
          <p className="mt-2 text-sm text-accent-900/80">随时欢迎联系我们，我们会认真回复每一条留言。</p>
          <Link to="/contact" className="mt-5 inline-flex items-center gap-2 rounded-full bg-accent-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap">
            去联系
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}